import type { ReactElement } from "react";
import React, { useState } from "react";
import type { RouterProps } from "react-router-dom";
import { Router, Routes, Route, Navigate } from "react-router-dom";

import { Layout, Drawer } from "antd";

import { UserData } from "./model/model";

import Header from "./components/Header";
import Menu from "./components/Menu";

// dashboard
import Dashboard from "./views/dashboard/Dashboard";
import SiteRedirect from "./views/sites/SiteRedirect";

// users
import Login from "./views/users/Login";
import ListUsers from "./views/users/ListUsers";
import CreateUser from "./views/users/CreateUser";
import EditUser from "./views/users/EditUser";
import ChangeUserPassword from "./views/users/ChangeUserPassword";
import EditInOut from "./views/in-out/EditInOut";

// device-profile templates
import ListDeviceProfiles from "./views/device-profiles/ListDeviceProfiles";
import CreateDeviceProfile from "./views/device-profiles/CreateDeviceProfile";
import EditDeviceProfile from "./views/device-profiles/EditDeviceProfile";

import CreateSite from "./views/sites/CreateSite";
import ListSites from "./views/sites/ListSite";
import SessionStore from "./model/SessionStore";

import history from "./history";
import ListInOuts from "./views/in-out/ListInOuts";
import CreateInOut from "./views/in-out/CreateInOut";
import SiteLoader from "./views/sites/SiteLoader";
import ListGateways from "./views/gateways/ListGateways";
import CreateGateway from "./views/gateways/CreateGateway";
import GatewayLayout from "./views/gateways/GatewayLayout";

interface IProps extends Omit<RouterProps, "location" | "navigationType" | "navigator"> {
  history: typeof history;
  children: (ReactElement | undefined)[];
}

const CustomRouter = ({ history, ...props }: IProps) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  React.useLayoutEffect(() => history.listen(setState), [history]);

  return <Router {...props} location={state.location} navigationType={state.action} navigator={history} />;
};

function App() {
  const [userData, setUser] = useState<UserData | undefined>(SessionStore.getUser());
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  React.useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  SessionStore.on("change", () => {
    console.log('change udss',SessionStore.getUser());
    setUser(SessionStore.getUser());
    console.log('change ud',userData);
  });

  return (
     <Layout style={{ minHeight: "100vh" }}>
      <CustomRouter history={history}>
        <Routes>
          <Route path="/" element={userData?<SiteRedirect />:<Navigate  to="/login" />} />
          <Route path="/login" element={<Login />} />
        </Routes>

        {userData && (
          <div>
            <Layout.Header className="layout-header">
              <Header userData={userData} isMobile={isMobile} onMenuClick={() => setDrawerOpen(true)} />
            </Layout.Header>
            {isMobile ? (
              <Layout.Content className="layout-content" style={{ padding: "24px 24px 24px" }}>
                <Routes>
                  <Route path="/dash" element={<Dashboard />} />

                  <Route path="/sites" element={<ListSites />} />
                  <Route path="/site/:siteId/*" element={<SiteLoader />} />
                  <Route path="/site/:siteId" element={<SiteLoader />} />
                  <Route path="/sites/create" element={<CreateSite/>} />

                  <Route path="/users" element={<ListUsers />} />
                  <Route path="/users/create" element={<CreateUser />} />
                  <Route path="/user/:userId" element={<EditUser />} />
                  <Route path="/user/:userId/password" element={<ChangeUserPassword />} />

                  <Route path="/ios" element={<ListInOuts />} />
                  <Route path="/io/:ioId" element={<EditInOut />} />
                  <Route path="/ios/create" element={<CreateInOut />} />

                  <Route path="/device-profiles" element={<ListDeviceProfiles/>} />
                  <Route path="/device-profiles/create" element={<CreateDeviceProfile/>} />
                  <Route path="/device-profiles/:devProfileId/edit" element={<EditDeviceProfile/>} />

                  {/* <Route path="/gateways" element={<ListGateways/>} />
                  <Route path="/gateways/create" element={<CreateGateway/>} />
                  <Route path="/gateways/:gatewayId/*" element={<GatewayLayout />} />
                  <Route path="/gateways/:gatewayId" element={<GatewayLayout />} /> */}
                </Routes>
              </Layout.Content>
            ) : (
              <Layout className="layout">
                <Layout.Sider width="300" theme="light" className="layout-menu">
                  <Menu />
                </Layout.Sider>
                <Layout.Content className="layout-content" style={{ padding: "24px 24px 24px" }}>
                  <Routes>
                    <Route path="/dash" element={<Dashboard />} />

                    <Route path="/sites" element={<ListSites />} />
                    <Route path="/site/:siteId/*" element={<SiteLoader />} />
                    <Route path="/site/:siteId" element={<SiteLoader />} />
                    <Route path="/sites/create" element={<CreateSite/>} />

                    <Route path="/users" element={<ListUsers />} />
                    <Route path="/users/create" element={<CreateUser />} />
                    <Route path="/user/:userId" element={<EditUser />} />
                    <Route path="/user/:userId/password" element={<ChangeUserPassword />} />

                    <Route path="/ios" element={<ListInOuts />} />
                    <Route path="/io/:ioId" element={<EditInOut />} />
                    <Route path="/ios/create" element={<CreateInOut />} />

                    <Route path="/device-profiles" element={<ListDeviceProfiles/>} />
                    <Route path="/device-profiles/create" element={<CreateDeviceProfile/>} />
                    <Route path="/device-profiles/:devProfileId/edit" element={<EditDeviceProfile/>} />

                    {/* <Route path="/gateways" element={<ListGateways/>} />
                    <Route path="/gateways/create" element={<CreateGateway/>} />
                    <Route path="/gateways/:gatewayId/*" element={<GatewayLayout />} />
                    <Route path="/gateways/:gatewayId" element={<GatewayLayout />} /> */}
                  </Routes>
                </Layout.Content>
              </Layout>
            )}
            <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)} placement="left" width={300}>
              <Menu />
            </Drawer>
          </div>
        )}
      </CustomRouter>
    </Layout>
  );
}

export default App;
